import { render, staticRenderFns } from "./Zoningmanagement.vue?vue&type=template&id=a9b773e8&scoped=true&"
import script from "./Zoningmanagement.vue?vue&type=script&lang=js&"
export * from "./Zoningmanagement.vue?vue&type=script&lang=js&"
import style0 from "./Zoningmanagement.vue?vue&type=style&index=0&id=a9b773e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b773e8",
  null
  
)

export default component.exports